module.exports = __webpack_public_path__ + "static/media/truck-type.9b83bb84.svg";